import { AssessmentType } from "../../../api/main/models/codeOnly/AssessmentType";
import { LaunchAssessmentBase } from "../launch/LaunchAssessmentBase";

/**
 * View results for a training session.
 */
export const TrainingResults = () => (<LaunchAssessmentBase defaultAssessmentType={AssessmentType.TrainingModule} finishPageOnly={true} />);
